<template>
  <div class="app">
    <router-view/>
    <footer>
      <footer-bar/>
    </footer>
  </div>
</template>

<script>
import FooterBar from '@/components/FooterBar';
export default {
  name: "App",
  components: {
    FooterBar,
  }
}
</script>

<style lang="scss">
body {
  font-family: "GTWalsheimPro", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #1E252E;
}

.hidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: hidden;
}

* {
  font-size: 21px;
  @media (max-width: 767px) {
    font-size: 18px;
  }
}

.app {
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: 767px) {
    padding: 48px 0 0;
  }

  * {
    box-sizing: border-box;
  }
}

a.router-link {
  font-size: 18px;
  line-height: 1;
  display: block;
  margin: 0 0 10px;

  &.router-link-active {
    opacity: .4;
  }
  @media (max-width: 767px) {
    margin: 0 0 20px;
    &:last-child {
      margin: 0;
    }
  }
}

a {
  text-decoration: none;
  color: #1E252E;
}

p {
  margin: 0 0 15px;
  @media (max-width: 767px) {
    margin: 0 0 10px;
  }
}

ul, ol {
  margin: 0 0 20px 21px;
  padding: 0;
  font-weight: 500;
  @media (max-width: 767px) {
    margin: 0 20px 20px;
  }
}

li {
  margin: 0 0 5px;
}

.note {
  font-size: 14px;
}

footer {
  background: #E8E8E8;
  padding: 50px 50px 0;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 380px;
    background-image: url(assets/waves_grey.svg);
    background-repeat: no-repeat;
    background-position: 100% 50%;
    background-size: 380px auto;
    transform: scaleX(-1);
  }

  @media (max-width: 767px) {
    padding: 15px 10px 0;
  }

  a.note {
    font-weight: 400;
  }

  a.router-link {
    font-size: 16px;

    @media (max-width: 767px) {
      font-size: 14px;
      margin: 0 0 5px;
    }
  }

  p {
    font-size: 16px;
    font-weight: 300;
    line-height: 1;
    margin: 0;
    @media (max-width: 767px) {
      margin: 0 0 5px;
      font-size: 14px;
    }
    a {
      @media (max-width: 767px) {
        margin: 0 0 5px;
        font-size: 14px;
      }
    }
  }

  p.note {
    font-weight: 300;
    line-height: 1.3;
    letter-spacing: -1px;
    @media (max-width: 767px) {
      margin: -15px 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?42f17b7e